import * as React from "react";
import styled, { css } from "styled-components";
import CommonSortIcon from "components/common/SortIcon";
const StyledCommonSortIcon = styled(CommonSortIcon)(
  ({ theme }) => css`
    display: inline-block;
    margin-left: ${theme.spacings.xs};
    padding: 0;
    cursor: pointer;
  `
);
const SORT_DIRECTIONS = {
  ASC: "asc",
  DESC: "desc"
};
const SORT_ORDER_NAMES = {
  asc: "ascending",
  desc: "descending"
};
const SortIcon = ({ column }) => {
  const nextSortDirection = column.getNextSortingOrder() || SORT_DIRECTIONS.ASC;
  const columnMeta = column.columnDef.meta;
  return /* @__PURE__ */ React.createElement(
    StyledCommonSortIcon,
    {
      activeDirection: column.getIsSorted() || null,
      onChange: () => column.toggleSorting(),
      title: `Sort ${columnMeta.label.toLowerCase()} ${SORT_ORDER_NAMES[nextSortDirection]}`,
      ascId: SORT_DIRECTIONS.ASC,
      descId: SORT_DIRECTIONS.DESC
    }
  );
};
export default SortIcon;
